import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.promise.finally";
import _classCallCheck from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { ArgumentNullError } from "./Error";
export var PromiseState;

(function (PromiseState) {
  PromiseState[PromiseState["None"] = 0] = "None";
  PromiseState[PromiseState["Resolved"] = 1] = "Resolved";
  PromiseState[PromiseState["Rejected"] = 2] = "Rejected";
})(PromiseState || (PromiseState = {}));

export var PromiseResult = /*#__PURE__*/function () {
  function PromiseResult(promiseResultEventSource) {
    var _this = this;

    _classCallCheck(this, PromiseResult);

    this.throwIfError = function () {
      if (_this.isError) {
        throw _this.error;
      }
    };

    promiseResultEventSource.on(function (result) {
      if (!_this.privIsCompleted) {
        _this.privIsCompleted = true;
        _this.privIsError = false;
        _this.privResult = result;
      }
    }, function (error) {
      if (!_this.privIsCompleted) {
        _this.privIsCompleted = true;
        _this.privIsError = true;
        _this.privError = error;
      }
    });
  }

  _createClass(PromiseResult, [{
    key: "isCompleted",
    get: function get() {
      return this.privIsCompleted;
    }
  }, {
    key: "isError",
    get: function get() {
      return this.privIsError;
    }
  }, {
    key: "error",
    get: function get() {
      return this.privError;
    }
  }, {
    key: "result",
    get: function get() {
      return this.privResult;
    }
  }]);

  return PromiseResult;
}(); // tslint:disable-next-line:max-classes-per-file

export var PromiseResultEventSource = function PromiseResultEventSource() {
  var _this2 = this;

  _classCallCheck(this, PromiseResultEventSource);

  this.setResult = function (result) {
    _this2.privOnSetResult(result);
  };

  this.setError = function (error) {
    _this2.privOnSetError(error);
  };

  this.on = function (onSetResult, onSetError) {
    _this2.privOnSetResult = onSetResult;
    _this2.privOnSetError = onSetError;
  };
}; // tslint:disable-next-line:max-classes-per-file

export var PromiseHelper = function PromiseHelper() {
  _classCallCheck(this, PromiseHelper);
};

PromiseHelper.whenAll = function (promises) {
  if (!promises || promises.length === 0) {
    throw new ArgumentNullError("promises");
  }

  var deferred = new Deferred();
  var errors = [];
  var completedPromises = 0;

  var checkForCompletion = function checkForCompletion() {
    completedPromises++;

    if (completedPromises === promises.length) {
      if (errors.length === 0) {
        deferred.resolve(true);
      } else {
        deferred.reject(errors.join(", "));
      }
    }
  };

  var _iterator = _createForOfIteratorHelper(promises),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var promise = _step.value;
      promise.on(function (r) {
        checkForCompletion();
      }, function (e) {
        errors.push(e);
        checkForCompletion();
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return deferred.promise();
};

PromiseHelper.fromResult = function (result) {
  var deferred = new Deferred();
  deferred.resolve(result);
  return deferred.promise();
};

PromiseHelper.fromError = function (error) {
  var deferred = new Deferred();
  deferred.reject(error);
  return deferred.promise();
}; // TODO: replace with ES6 promises
// tslint:disable-next-line:max-classes-per-file


export var Promise = function Promise(sink) {
  var _this3 = this;

  _classCallCheck(this, Promise);

  this.result = function () {
    return _this3.privSink.result;
  };

  this.continueWith = function (continuationCallback) {
    if (!continuationCallback) {
      throw new ArgumentNullError("continuationCallback");
    }

    var continuationDeferral = new Deferred();

    _this3.privSink.on(function (r) {
      try {
        var continuationResult = continuationCallback(_this3.privSink.result);
        continuationDeferral.resolve(continuationResult);
      } catch (e) {
        continuationDeferral.reject(e);
      }
    }, function (error) {
      try {
        var continuationResult = continuationCallback(_this3.privSink.result);
        continuationDeferral.resolve(continuationResult);
      } catch (e) {
        continuationDeferral.reject("'Error handler for error ".concat(error, " threw error ").concat(e, "'"));
      }
    });

    return continuationDeferral.promise();
  };

  this.onSuccessContinueWith = function (continuationCallback) {
    if (!continuationCallback) {
      throw new ArgumentNullError("continuationCallback");
    }

    var continuationDeferral = new Deferred();

    _this3.privSink.on(function (r) {
      try {
        var continuationResult = continuationCallback(r);
        continuationDeferral.resolve(continuationResult);
      } catch (e) {
        continuationDeferral.reject(e);
      }
    }, function (error) {
      continuationDeferral.reject(error);
    });

    return continuationDeferral.promise();
  };

  this.continueWithPromise = function (continuationCallback) {
    if (!continuationCallback) {
      throw new ArgumentNullError("continuationCallback");
    }

    var continuationDeferral = new Deferred();

    _this3.privSink.on(function (r) {
      try {
        var continuationPromise = continuationCallback(_this3.privSink.result);

        if (!continuationPromise) {
          throw new Error("'Continuation callback did not return promise'");
        }

        continuationPromise.on(function (continuationResult) {
          continuationDeferral.resolve(continuationResult);
        }, function (e) {
          continuationDeferral.reject(e);
        });
      } catch (e) {
        continuationDeferral.reject(e);
      }
    }, function (error) {
      try {
        var continuationPromise = continuationCallback(_this3.privSink.result);

        if (!continuationPromise) {
          throw new Error("Continuation callback did not return promise");
        }

        continuationPromise.on(function (continuationResult) {
          continuationDeferral.resolve(continuationResult);
        }, function (e) {
          continuationDeferral.reject(e);
        });
      } catch (e) {
        continuationDeferral.reject("'Error handler for error ".concat(error, " threw error ").concat(e, "'"));
      }
    });

    return continuationDeferral.promise();
  };

  this.onSuccessContinueWithPromise = function (continuationCallback) {
    if (!continuationCallback) {
      throw new ArgumentNullError("continuationCallback");
    }

    var continuationDeferral = new Deferred();

    _this3.privSink.on(function (r) {
      try {
        var continuationPromise = continuationCallback(r);

        if (!continuationPromise) {
          throw new Error("Continuation callback did not return promise");
        }

        continuationPromise.on(function (continuationResult) {
          continuationDeferral.resolve(continuationResult);
        }, function (e) {
          continuationDeferral.reject(e);
        });
      } catch (e) {
        continuationDeferral.reject(e);
      }
    }, function (error) {
      continuationDeferral.reject(error);
    });

    return continuationDeferral.promise();
  };

  this.on = function (successCallback, errorCallback) {
    if (!successCallback) {
      throw new ArgumentNullError("successCallback");
    }

    if (!errorCallback) {
      throw new ArgumentNullError("errorCallback");
    }

    _this3.privSink.on(successCallback, errorCallback);

    return _this3;
  };

  this.finally = function (callback) {
    if (!callback) {
      throw new ArgumentNullError("callback");
    }

    var callbackWrapper = function callbackWrapper(_) {
      callback();
    };

    return _this3.on(callbackWrapper, callbackWrapper);
  };

  this.privSink = sink;
}; // tslint:disable-next-line:max-classes-per-file

export var Deferred = function Deferred() {
  var _this4 = this;

  _classCallCheck(this, Deferred);

  this.state = function () {
    return _this4.privSink.state;
  };

  this.promise = function () {
    return _this4.privPromise;
  };

  this.resolve = function (result) {
    _this4.privSink.resolve(result);

    return _this4;
  };

  this.reject = function (error) {
    _this4.privSink.reject(error);

    return _this4;
  };

  this.privSink = new Sink();
  this.privPromise = new Promise(this.privSink);
}; // tslint:disable-next-line:max-classes-per-file

export var Sink = /*#__PURE__*/function () {
  function Sink() {
    var _this5 = this;

    _classCallCheck(this, Sink);

    this.privState = PromiseState.None;
    this.privPromiseResult = null;
    this.privPromiseResultEvents = null;
    this.privSuccessHandlers = [];
    this.privErrorHandlers = [];

    this.resolve = function (result) {
      if (_this5.privState !== PromiseState.None) {
        throw new Error("'Cannot resolve a completed promise'");
      }

      _this5.privState = PromiseState.Resolved;

      _this5.privPromiseResultEvents.setResult(result);

      for (var i = 0; i < _this5.privSuccessHandlers.length; i++) {
        _this5.executeSuccessCallback(result, _this5.privSuccessHandlers[i], _this5.privErrorHandlers[i]);
      }

      _this5.detachHandlers();
    };

    this.reject = function (error) {
      if (_this5.privState !== PromiseState.None) {
        throw new Error("'Cannot reject a completed promise'");
      }

      _this5.privState = PromiseState.Rejected;

      _this5.privPromiseResultEvents.setError(error);

      var _iterator2 = _createForOfIteratorHelper(_this5.privErrorHandlers),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var errorHandler = _step2.value;

          _this5.executeErrorCallback(error, errorHandler);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      _this5.detachHandlers();
    };

    this.on = function (successCallback, errorCallback) {
      if (successCallback == null) {
        successCallback = function successCallback(r) {
          return;
        };
      }

      if (_this5.privState === PromiseState.None) {
        _this5.privSuccessHandlers.push(successCallback);

        _this5.privErrorHandlers.push(errorCallback);
      } else {
        if (_this5.privState === PromiseState.Resolved) {
          _this5.executeSuccessCallback(_this5.privPromiseResult.result, successCallback, errorCallback);
        } else if (_this5.privState === PromiseState.Rejected) {
          _this5.executeErrorCallback(_this5.privPromiseResult.error, errorCallback);
        }

        _this5.detachHandlers();
      }
    };

    this.executeSuccessCallback = function (result, successCallback, errorCallback) {
      try {
        successCallback(result);
      } catch (e) {
        _this5.executeErrorCallback("'Unhandled callback error: ".concat(e, "'"), errorCallback);
      }
    };

    this.executeErrorCallback = function (error, errorCallback) {
      if (errorCallback) {
        try {
          errorCallback(error);
        } catch (e) {
          throw new Error("'Unhandled callback error: ".concat(e, ". InnerError: ").concat(error, "'"));
        }
      } else {
        throw new Error("'Unhandled error: ".concat(error, "'"));
      }
    };

    this.detachHandlers = function () {
      _this5.privErrorHandlers = [];
      _this5.privSuccessHandlers = [];
    };

    this.privPromiseResultEvents = new PromiseResultEventSource();
    this.privPromiseResult = new PromiseResult(this.privPromiseResultEvents);
  }

  _createClass(Sink, [{
    key: "state",
    get: function get() {
      return this.privState;
    }
  }, {
    key: "result",
    get: function get() {
      return this.privPromiseResult;
    }
  }]);

  return Sink;
}();